<app-masterpage>
</app-masterpage>
<div class="page-wrapper">
    <app-header>
    </app-header>
    <div class="container-fluid pt-custom pb-5">
        <!-- onclick="outerbody();" -->
        <div class="row">
            <div class="col-10">
                <h4 class="fs-title">College Registration:</h4>
            </div>
        </div>
        <div class="row card">
            <div class="col-lg-12">
                <div class="row justify-content-center">
                    <div class="col-lg-12 col-md-12 col-12 p-4">
                        <form #RegistrationForm="ngForm" id="RegistrationForm" class="msform">
                            <div class="row mt-2">
                                <div class="form-group col-lg-2 col-md-12 col-12">
                                    <label><b>University</b><span class="text-danger">*</span></label> <br>
                                    <label *ngFor="let b of boards; let i=index">
                                        <input type="checkbox" id="chkBoard{{i}}" name="chkBoard{{i}}" disabled />
                                        &nbsp;&nbsp; {{b.text}} &nbsp;&nbsp;
                                    </label>
                                    <span *ngIf="RegistrationForm.submitted ">
                                        <p *ngIf="data.Board == '' " class="error_message" style="color: red;">
                                            University is required
                                        </p>
                                    </span>
                                </div>
                                <div class="form-group col-lg-3 col-md-12 col-12">
                                    <label><b>Medium</b><span class="text-danger">*</span></label><br>
                                    <label *ngFor="let m of mediums; let i=index">
                                        <input type="checkbox" id="chkmedium{{i}}" name="chkmedium{{i}}" disabled />
                                        &nbsp;&nbsp; {{m.text}} &nbsp;&nbsp;
                                    </label>
                                    <span *ngIf="RegistrationForm.submitted ">
                                        <p *ngIf="data.Medium == ''" class="error_message" style="color: red;">
                                            Medium is required
                                        </p>
                                    </span>
                                </div>
                                <div class="form-group col-lg-3 col-md-12 col-12">
                                    <label><b>Institute</b><span class="text-danger">*</span></label><br>
                                    <label *ngFor="let ins of institutetypes; let i=index">
                                        <input type="checkbox" id="chkinstitute{{i}}" name="chkinstitute{{i}}" [value]="ins.value"
                                         disabled />
                                        &nbsp;&nbsp; {{ins.text}} &nbsp;&nbsp;
                                    </label>
                                    <span *ngIf="RegistrationForm.submitted ">
                                        <p *ngIf="data.InstituteTypeID == ''" class="error_message" style="color: red;">
                                            Institute Type is required
                                        </p>
                                    </span>
                                </div>
                                <div class="form-group col-lg-4 col-md-12 col-12">
                                    <label><b>Faculty</b><span class="text-danger">*</span></label> <br />
                                    <label *ngFor="let s of sections; let i=index">
                                        <input type="checkbox" id="chksection{{i}}" name="chksection{{i}}" disabled />
                                        &nbsp;&nbsp; {{s.text}} &nbsp;&nbsp;
                                    </label>
                                    <span *ngIf="RegistrationForm.submitted ">
                                        <p *ngIf="data.Section == ''" class="error_message" style="color: red;">
                                            Faculty is required
                                        </p>
                                    </span>
                                </div>
                            </div>
                            <div class="row mt-2">
                                <div class="form-group col-lg-10 col-md-12 col-12">
                                    <label><b>Course</b><span class="text-danger">*</span></label> <br />
                                    <label *ngFor="let d of documentList; let i=index">
                                        <input type="checkbox" id="chkStd{{i}}" name="chkStd{{i}}" disabled checked />
                                        &nbsp;&nbsp; {{d.text}} &nbsp;&nbsp;
                                    </label>
                                </div>
                            </div>
                            <div class="row mt-2">
                                <div class="form-group col-lg-4 col-md-12 col-12">
                                    <label><b>College code</b><span class="text-danger">*</span></label>
                                    <input type="text" class="form-control" #UDiseNo="ngModel" ngModel name="UDiseNo"
                                        [(ngModel)]="data.UDiseNo" placeholder="Enter college code" maxlength="50"
                                        required>
                                    <span *ngIf="RegistrationForm.submitted && UDiseNo.invalid">
                                        <p *ngIf="UDiseNo.errors.required" class="error_message" style="color: red;">
                                            College code is required
                                        </p>
                                    </span>
                                </div>
                                <!-- <div class="form-group col-lg-4 col-md-12 col-12">
                                    <label><b>S.S.C. INDEX NO.</b></label>
                                    <input type="text" class="form-control" #SSCIndexNo="ngModel" ngModel
                                        name="SSCIndexNo" [(ngModel)]="data.SSCIndexNo" maxlength="50"
                                        style="text-transform: uppercase;" placeholder="ENTER S.S.C. INDEX NO.">
                                </div>
                                <div class="form-group col-lg-4 col-md-12 col-12">
                                    <label><b>H.S.C. INDEX NO.</b></label>
                                    <input type="text" class="form-control" #HSCIndexNO="ngModel" ngModel
                                        name="HSCIndexNO" [(ngModel)]="data.HSCIndexNO" maxlength="50"
                                        style="text-transform: uppercase;" placeholder="ENTER H.S.C. INDEX NO.">
                                </div> -->
                                <!-- </div>
                            <div class="row mt-2">
                                <div class="form-group col-lg-4 col-md-12 col-12">
                                    <label><b>Office</b><span class="text-danger">*</span></label>
                                    <select class="form-control" #Office="ngModel" ngModel name="Office"
                                        [(ngModel)]="data.Office" required>
                                        <option *ngFor="let office of offices" [value]="office.value"
                                            [selected]="data.Office == office.value">
                                            {{ office.text }}
                                        </option>
                                    </select>
                                    <span *ngIf="RegistrationForm.submitted ">
                                        <p *ngIf="data.Office == 0" class="error_message" style="color: red;">
                                            Office is required
                                        </p>
                                    </span>
                                </div> -->
                                <div class="form-group col-lg-4 col-md-12 col-12">
                                    <label><b>Type of trust</b><span class="text-danger">*</span></label>
                                    <select class="form-control" #TypeOfTrust="ngModel" ngModel name="TypeOfTrust"
                                        [(ngModel)]="data.TypeOfTrust" required>
                                        <option *ngFor="let typeoftrust of typeOfTrusts" [value]="typeoftrust.value"
                                            [selected]="data.TypeOfTrust == typeoftrust.value">
                                            {{ typeoftrust.text }}
                                        </option>
                                    </select>
                                    <span *ngIf="RegistrationForm.submitted">
                                        <p *ngIf="data.TypeOfTrust == 0" class="error_message" style="color: red;">
                                            Type of trust is required
                                        </p>
                                    </span>
                                </div>
                                <!-- <div class="form-group col-lg-4 col-md-12 col-12" *ngIf="visibleAquireDate">
                                    <label><b>Index no. acquire date</b><span class="text-danger">*</span></label>
                                    <input type="date" placeholder="Select Date" id="AcquiredDate" class="form-control"
                                        #AcquiredDate="ngModel" ngModel name="AcquiredDate"
                                        [(ngModel)]="data.AcquiredDate" required>
                                    <span
                                        *ngIf="RegistrationForm.submitted && AcquiredDate.invalid && visibleAquireDate">
                                        <p *ngIf="AcquiredDate.errors.required" class="error_message"
                                            style="color: red;">
                                            Index no. acquire date is required
                                        </p>
                                    </span>
                                </div> -->
                            </div>
                            <div class="row mt-2" *ngIf="visibleAffiliation">
                                <div class="form-group col-lg-4 col-md-12 col-12">
                                    <label><b>Affiliation no.</b><span class="text-danger">*</span></label>
                                    <input type="text" class="form-control" #AffiliationNumber="ngModel" ngModel
                                        name="AffiliationNumber" [(ngModel)]="data.AffiliationNumber" maxlength="100"
                                        placeholder="Enter affiliation no." required>
                                    <span
                                        *ngIf="RegistrationForm.submitted && AffiliationNumber.invalid && visibleAffiliation">
                                        <p *ngIf="AffiliationNumber.errors.required" class="error_message"
                                            style="color: red;">
                                            Affiliation no. is required
                                        </p>
                                    </span>
                                </div>
                                <div class="form-group col-lg-4 col-md-12 col-12">
                                    <label><b>Affiliation no. acquire date</b><span class="text-danger">*</span></label>
                                    <input type="date" placeholder="Select affiliation no. acquire date"
                                        id="AffiliationNumberAcquireDate" class="form-control"
                                        #AffiliationNumberAcquireDate="ngModel" ngModel
                                        name="AffiliationNumberAcquireDate"
                                        [(ngModel)]="data.AffiliationNumberAcquireDate" required>
                                    <span
                                        *ngIf="RegistrationForm.submitted && AffiliationNumberAcquireDate.invalid && visibleAffiliation">
                                        <p *ngIf="AffiliationNumberAcquireDate.errors.required" class="error_message"
                                            style="color: red;">
                                            Affiliation no. acquire date is required
                                        </p>
                                    </span>
                                </div>
                            </div>
                            <div class="row mt-2">
                                <div class="form-group col-lg-4 col-md-12 col-12">
                                    <label><b>Area</b><span class="text-danger">*</span></label>
                                    <textarea class="form-control" #Area="ngModel" ngModel name="Area" rows="3"
                                        maxlength="300" style="height: 60px;" [(ngModel)]="data.Area"
                                        required></textarea>
                                    <span *ngIf="RegistrationForm.submitted && Area.invalid">
                                        <p *ngIf="Area.errors.required" class="error_message" style="color: red;">
                                            Area is required
                                        </p>
                                    </span>
                                </div>
                                <div class="form-group col-lg-4 col-md-12 col-12">
                                    <label><b>State</b><span class="text-danger">*</span></label>
                                    <select class="form-control" #State="ngModel" ngModel name="State"
                                        (change)="fillCity()" [(ngModel)]="data.State" required>
                                        <option *ngFor="let state of states" [value]="state.value"
                                            [selected]="data.State == state.value">
                                            {{ state.text }}
                                        </option>
                                    </select>
                                    <span *ngIf="RegistrationForm.submitted ">
                                        <p *ngIf="data.State == 0" class="error_message" style="color: red;">
                                            State is required
                                        </p>
                                    </span>
                                </div>
                                <div class="form-group col-lg-4 col-md-12 col-12">
                                    <label><b>City</b><span class="text-danger">*</span></label>
                                    <select class="form-control" #City="ngModel" ngModel name="City"
                                        [(ngModel)]="data.City" required>
                                        <option *ngFor="let city of cities" [value]="city.value"
                                            [selected]="data.City == city.value">
                                            {{ city.text }}
                                        </option>
                                    </select>
                                    <span *ngIf="RegistrationForm.submitted ">
                                        <p *ngIf="data.City == 0 || data.City == undefined" class="error_message"
                                            style="color: red;">
                                            City is required
                                        </p>
                                    </span>
                                </div>
                            </div>
                            <div class="row mt-2">
                                <div class="form-group col-lg-4 col-md-12 col-12">
                                    <label><b>Trust name</b><span class="text-danger">*</span></label>
                                    <input type="text" class="form-control" #Trust="ngModel" ngModel name="Trust"
                                        [(ngModel)]="data.Trust" maxlength="200" placeholder="Enter trust name"
                                        required>
                                    <span *ngIf="RegistrationForm.submitted && Trust.invalid">
                                        <p *ngIf="Trust.errors.required" class="error_message" style="color: red;">
                                            Trust name is required
                                        </p>
                                    </span>
                                </div>
                                <div class="form-group col-lg-4 col-md-12 col-12">
                                    <label><b>Trust address</b><span class="text-danger">*</span></label>
                                    <input type="text" class="form-control" #TrustAddress="ngModel" ngModel
                                        name="TrustAddress" [(ngModel)]="data.TrustAddress" maxlength="300"
                                        placeholder="Enter trust address" (keypress)="blockSpecialChar($event)"
                                        required>
                                    <span *ngIf="RegistrationForm.submitted && TrustAddress.invalid">
                                        <p *ngIf="TrustAddress.errors.required" class="error_message"
                                            style="color: red;">
                                            Trust address is required
                                        </p>
                                    </span>
                                </div>
                                <div class="form-group col-lg-4 col-md-12 col-12">
                                    <label><b>Contact / Mobile no.</b><span class="text-danger">*</span></label>
                                    <input type="text" class="form-control" #TrustMobileNo="ngModel" ngModel
                                        name="TrustMobileNo" [(ngModel)]="data.TrustMobileNo" numbersOnly minlength="10"
                                        maxlength="10" placeholder="Enter contact / mobile no." required>
                                    <span *ngIf="RegistrationForm.submitted && TrustMobileNo.invalid">
                                        <p *ngIf="TrustMobileNo.errors.required" class="error_message"
                                            style="color: red;">
                                            Contact / Mobile no. is required
                                        </p>
                                        <p *ngIf="TrustMobileNo.errors.minlength" class="error_message"
                                            style="color: red;">
                                            Contact / Mobile no. must be of 10 digit
                                        </p>
                                        <p *ngIf="TrustMobileNo.errors.maxlength" class="error_message"
                                            style="color: red;">
                                            Contact / Mobile no. must be of maximun 10 digit
                                        </p>
                                    </span>
                                </div>
                                <div class="form-group col-lg-4 col-md-12 col-12">
                                    <label><b>Trust mail id</b><span class="text-danger">*</span></label>
                                    <input type="text" class="form-control" #TrustMailID="ngModel" ngModel
                                        name="TrustMailID" [(ngModel)]="data.TrustMailID" maxlength="50"
                                        pattern="^[a-zA-Z0-9+_.-]+@[a-zA-Z0-9.-]+$" placeholder="Enter trust mail id"
                                        required>
                                    <span *ngIf="RegistrationForm.submitted && TrustMailID.invalid">
                                        <p *ngIf="TrustMailID.errors.required" class="error_message"
                                            style="color: red;">
                                            Trust mail id is required
                                        </p>
                                        <p *ngIf="TrustMailID.errors.pattern" class="error_message" style="color: red;">
                                            Trust mail id is invalid
                                        </p>
                                    </span>
                                </div>
                            </div>
                            <div class="row mt-2">
                                <div class="form-group col-lg-4 col-md-12 col-12">
                                    <label><b>College name</b><span class="text-danger">*</span></label>
                                    <input type="text" class="form-control" #SchoolName="ngModel" ngModel
                                        name="SchoolName" [(ngModel)]="data.SchoolName" maxlength="200"
                                        placeholder="Enter college name" required>
                                    <span *ngIf="RegistrationForm.submitted && SchoolName.invalid">
                                        <p *ngIf="SchoolName.errors.required" class="error_message" style="color: red;">
                                            College name is required
                                        </p>
                                    </span>
                                </div>
                                <div class="form-group col-lg-4 col-md-12 col-12">
                                    <label><b>College address</b><span class="text-danger">*</span></label>
                                    <input type="text" class="form-control" #SchoolAddress="ngModel" ngModel
                                        name="SchoolAddress" [(ngModel)]="data.SchoolAddress" maxlength="300"
                                        placeholder="Enter college address" (keypress)="blockSpecialChar($event)"
                                        required>
                                    <span *ngIf="RegistrationForm.submitted && SchoolAddress.invalid">
                                        <p *ngIf="SchoolAddress.errors.required" class="error_message"
                                            style="color: red;">
                                            College address is required
                                        </p>
                                    </span>
                                </div>
                                <div class="form-group col-lg-4 col-md-12 col-12">
                                    <label><b>College pincode</b><span class="text-danger">*</span></label>
                                    <input type="text" class="form-control" #pincode="ngModel" ngModel name="pincode"
                                        [(ngModel)]="data.Pincode" maxlength="6" placeholder="Enter college pincode"
                                        (keypress)="blockSpecialChar($event)" required>
                                    <span *ngIf="RegistrationForm.submitted && pincode.invalid">
                                        <p *ngIf="pincode.errors.required" class="error_message" style="color: red;">
                                            College pincode is required
                                        </p>
                                    </span>
                                </div>
                                <div class="form-group col-lg-4 col-md-12 col-12">
                                    <label><b>Contact / Mobile no.</b><span class="text-danger">*</span></label>
                                    <input type="text" class="form-control" #SchoolMobileno="ngModel" ngModel
                                        name="SchoolMobileno" [(ngModel)]="data.SchoolMobileno" minlength="10"
                                        numbersOnly maxlength="10" placeholder="Enter contact / mobile no." required>
                                    <span *ngIf="RegistrationForm.submitted && SchoolMobileno.invalid">
                                        <p *ngIf="SchoolMobileno.errors.required" class="error_message"
                                            style="color: red;">
                                            Contact / Mobile no. is required
                                        </p>
                                        <p *ngIf="SchoolMobileno.errors.minlength" class="error_message"
                                            style="color: red;">
                                            Contact / mobile no. must be of 10 digit
                                        </p>
                                        <p *ngIf="SchoolMobileno.errors.maxlength" class="error_message"
                                            style="color: red;">
                                            Contact / mobile no. must be of maximun 10 digit
                                        </p>
                                    </span>
                                </div>
                                <div class="form-group col-lg-4 col-md-12 col-12">
                                    <label><b>College mail id</b><span class="text-danger">*</span></label>
                                    <input type="text" class="form-control" #SchoolMailID="ngModel" ngModel
                                        name="SchoolMailID" [(ngModel)]="data.SchoolMailID" maxlength="50"
                                        pattern="^[a-zA-Z0-9+_.-]+@[a-zA-Z0-9.-]+$" placeholder="Enter college mail id"
                                        required>
                                    <span *ngIf="RegistrationForm.submitted && SchoolMailID.invalid">
                                        <p *ngIf="SchoolMailID.errors.required" class="error_message"
                                            style="color: red;">
                                            College mail id is required
                                        </p>
                                        <p *ngIf="SchoolMailID.errors.pattern" class="error_message"
                                            style="color: red;">
                                            College mail id is invalid
                                        </p>
                                    </span>
                                </div>
                            </div>
                            <div class="row mt-2">
                                <div class="form-group col-lg-4 col-md-12 col-12">
                                    <label><b>College location</b><span class="text-danger">*</span></label>
                                    <select class="form-control" #SchoolLocation="ngModel" ngModel name="SchoolLocation"
                                        [(ngModel)]="data.SchoolLocation" required>
                                        <option *ngFor="let location of locations" [value]="location.value"
                                            [selected]="data.SchoolLocation == location.value">
                                            {{ location.text }}
                                        </option>
                                    </select>
                                    <span *ngIf="RegistrationForm.submitted ">
                                        <p *ngIf="data.SchoolLocation == 0 || data.SchoolLocation == undefined"
                                            class="error_message" style="color: red;">
                                            College location is required
                                        </p>
                                    </span>
                                </div>
                                <div class="form-group col-lg-4 col-md-12 col-12">
                                    <label><b>College type</b><span class="text-danger">*</span></label>
                                    <select class="form-control" #SchoolType="ngModel" ngModel name="SchoolType"
                                        [(ngModel)]="data.SchoolType" required>
                                        <option *ngFor="let type of types" [value]="type.value"
                                            [selected]="data.SchoolType == type.value">
                                            {{ type.text }}
                                        </option>
                                    </select>
                                    <span *ngIf="RegistrationForm.submitted ">
                                        <p *ngIf="data.SchoolType == 0 || data.SchoolType == undefined"
                                            class="error_message" style="color: red;">
                                            College type is required
                                        </p>
                                    </span>
                                </div>
                                <div class="form-group col-lg-4 col-md-12 col-12">
                                    <label><b>Registration date</b><span class="text-danger">*</span></label>
                                    <input type="date" placeholder="Select Date" id="RegistrationDate"
                                        class="form-control" #RegistrationDate="ngModel" ngModel name="RegistrationDate"
                                        [(ngModel)]="data.RegistrationDate" required>
                                    <span *ngIf="RegistrationForm.submitted && RegistrationDate.invalid">
                                        <p *ngIf="RegistrationDate.errors.required" class="error_message"
                                            style="color: red;">
                                            Registration date is required
                                        </p>
                                    </span>
                                </div>
                            </div>
                            <div class="border border-dark  bg-custom  p-2">
                                <h4>Trustee Details</h4>
                                <hr style="margin: 0;">
                                <div class="row mt-2 " style="margin: 2px;">
                                    <input type="hidden" value="-1" id="hid_trusteeDetailID">
                                    <div class="form-group col-lg-3 col-md-12 col-12 mb-0">
                                        <label><b>Trustee's name</b><span class="text-danger">*</span></label>
                                        <input type="text" class="form-control" #TrusteeName="ngModel" ngModel
                                            name="TrusteeName" [(ngModel)]="data.TrusteeName" maxlength="200"
                                            placeholder="Enter trustee's name">
                                    </div>
                                    <div class="form-group col-lg-3 col-md-12 col-12 mb-0">
                                        <label><b>Trustee Address</b><span class="text-danger">*</span></label>
                                        <input type="text" class="form-control" #TrusteeAddress="ngModel" ngModel
                                            name="TrusteeAddress" [(ngModel)]="data.TrusteeAddress" maxlength="300"
                                            (keypress)="blockSpecialChar($event)" placeholder="Enter trustee address">
                                    </div>
                                    <div class="form-group col-lg-3 col-md-12 col-12 mb-0">
                                        <label><b>Contact / Mobile no.</b><span class="text-danger">*</span></label>
                                        <input type="text" class="form-control" #TrusteeMobileNo="ngModel" ngModel
                                            name="TrusteeMobileNo" [(ngModel)]="data.TrusteeMobileNo" minlength="10"
                                            maxlength="10" placeholder="Enter Contact / Mobile no." numbersOnly>

                                    </div>
                                    <div class="form-group col-lg-3 col-md-12 col-12 mb-0">
                                        <label><b>Trustee's mail id</b><span class="text-danger">*</span></label>
                                        <input type="text" class="form-control" #TrusteeMailID="ngModel" ngModel
                                            name="TrusteeMailID" [(ngModel)]="data.TrusteeMailID" maxlength="50"
                                            placeholder="Enter trustee's mail id"
                                            pattern="^[a-zA-Z0-9+_.-]+@[a-zA-Z0-9.-]+$">
                                    </div>
                                </div>
                                <div class="row  mt-2">
                                    <div class="col-xl-1 col-md-2 col-3">
                                        <button class="btn btn-success ml-3" type="button" style="margin: 5px;"
                                            (click)="addTrustee()">Add</button>
                                    </div>
                                    <div class="col-xl-1 col-md-2 col-3">
                                        <button class="btn btn-primary" type="button" style="margin: 5px;"
                                            (click)="clearTrustee()">Clear</button>
                                    </div>
                                </div>
                                <div class="form-group col-lg-12 col-md-12 col-12 mt-4">
                                    <div class="table-responsive">
                                        <table class="table table-bordered" *ngIf="TrusteeDetail.length > 0">
                                            <thead>
                                                <tr>
                                                    <th>Trustee's name</th>
                                                    <th>Trustee's address</th>
                                                    <th>Trustee's Contact / Mobile no.</th>
                                                    <th>Trustee's mail id</th>
                                                    <th>Action</th>
                                                </tr>
                                            </thead>
                                            <tr *ngFor="let t of TrusteeDetail;let i = index">
                                                <td>{{t.TrusteeName}}</td>
                                                <td>{{t.TrusteeAddress}}</td>
                                                <td>{{t.TrusteeMobileNo}}</td>
                                                <td>{{t.TrusteeMailID}}</td>
                                                <td style="white-space: nowrap;">
                                                    <button type="button" class="btn btn-success mt-0 mb-0 d-inline"
                                                        (click)="editTrustee(i)">Edit</button>
                                                    &nbsp; <button type="button" class="btn btn-danger mt-0 d-inline"
                                                        (click)="deleteTrustee(i)">Delete</button>
                                                </td>
                                            </tr>
                                        </table>
                                    </div>
                                </div>
                            </div>
                            <div class="border border-dark  bg-custom  p-2 mt-2">
                                <h4>Infrastructure Details</h4>
                                <hr style="margin: 0;">
                                <div class="row mt-2 " style="margin: 2px;">
                                    <input type="hidden" value="-1" id="hid_InfrastructureDetailID">
                                    <div class="form-group col-lg-3 col-md-12 col-12">
                                        <label><b>Infrastructure Type</b><span class="text-danger">*</span></label>
                                        <select class="form-control" #InfrastructureID="ngModel" ngModel (change)="getInfraName();"
                                           id="InfrastructureID" name="InfrastructureID" [(ngModel)]="data.InfrastructureID" required>
                                            <option *ngFor="let inf of infrastructures" [value]="inf.value"
                                                [selected]="data.InfrastructureID == inf.value">
                                                {{ inf.text }}
                                            </option>
                                        </select>
                                    </div>
                                    <div class="form-group col-lg-3 col-md-12 col-12 mb-0">
                                        <label><b>No. of infrastructure</b><span class="text-danger">*</span></label>
                                        <input type="text" class="form-control" #NoOfInfrastructure="ngModel" ngModel
                                            name="NoOfInfrastructure" [(ngModel)]="data.NoOfInfrastructure"
                                            maxlength="10" placeholder="Enter no. of infrastructure" numbersOnly>
                                    </div>
                                    <div class="form-group col-lg-3 col-md-12 col-12 mb-0">
                                        <label><b>Infrastructure size (in Sq.Ft.)</b><span
                                                class="text-danger">*</span></label>
                                        <input type="text" class="form-control" #InfrastructureSize="ngModel" ngModel
                                            name="InfrastructureSize" [(ngModel)]="data.InfrastructureSize"
                                            maxlength="10" placeholder="Enter infrastructure size" numbersOnly>
                                    </div>
                                    <div class="form-group col-lg-3 col-md-12 col-12 mb-0" id="divotherinfra"
                                        style="display: none;">
                                        <div class="form-group">
                                            <label class="form-label "><b>Other Infrastructure
                                                    Type</b><span class="text-danger">*</span></label>
                                            <input class="form-control" type="text" name="OtherInfrastructure"
                                                placeholder="Enter other infrastructure type"
                                                [(ngModel)]="data.OtherInfrastructure" autocomplete="off"
                                                #OtherInfrastructure="ngModel" ngModel />
                                        </div>
                                    </div>
                                </div>
                                <div class="row  mt-2">
                                    <div class="col-xl-1 col-md-2 col-3">
                                        <button class="btn btn-success ml-3" type="button" style="margin: 5px;"
                                            (click)="addInfrastructure()">Add</button>
                                    </div>
                                    <div class="col-xl-1 col-md-2 col-3">
                                        <button class="btn btn-primary" type="button" style="margin: 5px;"
                                            (click)="clearInfrastructure()">Clear</button>
                                    </div>
                                </div>
                                <div class="form-group col-lg-12 col-md-12 col-12 mt-4"
                                    *ngIf="InfrastructureDetail.length > 0">
                                    <div class="table-responsive">
                                        <table class="table table-bordered">
                                            <thead>
                                                <tr>
                                                    <th>Infrastructure Type</th>
                                                    <th>No. of infrastructure</th>
                                                    <th>Infrastructure size (in Sq.Ft.)</th>
                                                    <th>Other infrastructure</th>
                                                    <th>Action</th>
                                                </tr>
                                            </thead>
                                            <tr *ngFor="let t of InfrastructureDetail;let i = index">
                                                <td>{{t.InfrastructureType}}</td>
                                                <td>{{t.NoOfInfrastructure}}</td>
                                                <td>{{t.InfrastructureSize}}</td>
                                                <td>{{t.OtherInfrastructure}}</td>
                                                <td style="white-space: nowrap;">
                                                    <button type="button" class="btn btn-success mt-0 mb-0 d-inline"
                                                        (click)="editInfrastructure(i)">Edit</button>
                                                    &nbsp; <button type="button" class="btn btn-danger mt-0 d-inline"
                                                        (click)="deleteInfrastructure(i)">Delete</button>
                                                </td>
                                            </tr>
                                        </table>
                                    </div>
                                </div>
                            </div>
                            <div class="border border-dark  bg-custom  p-2 mt-2">
                                <h4>Employee Details</h4>
                                <hr style="margin: 0;">
                                <div class="row mt-2 " style="margin: 2px;">
                                    <input type="hidden" value="-1" id="hid_EmployeeDetailID">
                                    <div class="form-group col-lg-4 col-md-12 col-12">
                                        <label><b>Employee Category</b><span class="text-danger">*</span></label>
                                        <select class="form-control" #EmployeeTypeID="ngModel" ngModel
                                            name="EmployeeTypeID" [(ngModel)]="data.EmployeeTypeID" required>
                                            <option *ngFor="let inf of employeetypes" [value]="inf.value"
                                                [selected]="data.EmployeeTypeID == inf.value">
                                                {{ inf.text }}
                                            </option>
                                        </select>
                                    </div>
                                    <div class="form-group col-lg-4 col-md-12 col-12 mb-0">
                                        <label><b>No. of permanent employee</b></label>
                                        <input type="text" class="form-control" #NoOfPermanentEmployee="ngModel" ngModel
                                            name="NoOfPermanentEmployee" [(ngModel)]="data.NoOfPermanentEmployee"
                                            maxlength="10" placeholder="Enter no. of permanent employee" numbersOnly>
                                    </div>
                                    <div class="form-group col-lg-4 col-md-12 col-12 mb-0">
                                        <label><b>No. of Ad-Hoc employee</b></label>
                                        <input type="text" class="form-control" #NoOfAdhocEmployee="ngModel" ngModel
                                            name="NoOfAdhocEmployee" [(ngModel)]="data.NoOfAdhocEmployee" maxlength="10"
                                            placeholder="Enter no. of Ad-Hoc employee" numbersOnly>
                                    </div>
                                </div>
                                <div class="row mt-2 " style="margin: 2px;">
                                    <div class="form-group col-lg-4 col-md-12 col-12 mb-0">
                                        <label><b>Total permanent employee's salary</b></label>
                                        <input type="text" class="form-control" #TotalPermanentSalary="ngModel" ngModel
                                            name="TotalPermanentSalary" [(ngModel)]="data.TotalPermanentSalary"
                                            maxlength="10" placeholder="Enter total permanent employee's salary"
                                            numbersOnly>
                                    </div>
                                    <div class="form-group col-lg-4 col-md-12 col-12 mb-0">
                                        <label><b>Total Ad-Hoc employee's salary</b></label>
                                        <input type="text" class="form-control" #TotalAdhocSalary="ngModel" ngModel
                                            name="TotalAdhocSalary" [(ngModel)]="data.TotalAdhocSalary" maxlength="10"
                                            placeholder="Enter total Ad-Hoc employee's salary" numbersOnly>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-xl-1 col-md-2 col-3">
                                        <label>&nbsp;</label>
                                        <button class="btn btn-success ml-3" type="button" style="margin: 5px;"
                                            (click)="addEmployeeDetail()">Add</button>
                                    </div>
                                    <div class="col-xl-1 col-md-2 col-3">
                                        <label>&nbsp;</label>
                                        <button class="btn btn-primary" type="button" style="margin: 5px;"
                                            (click)="clearEmployeeDetail()">Clear</button>
                                    </div>
                                </div>
                                <div class="form-group col-lg-12 col-md-12 col-12 mt-4"
                                    *ngIf="EmployeeDetail.length > 0">
                                    <div class="table-responsive">
                                        <table class="table table-bordered">
                                            <thead>
                                                <tr>
                                                    <th>Employee Category</th>
                                                    <th>No. of permanent employee</th>
                                                    <th>No. of Ad-Hoc employee</th>
                                                    <th>Total permanent employee's salary</th>
                                                    <th>Total Ad-Hoc employee's salary</th>
                                                    <th>Action</th>
                                                </tr>
                                            </thead>
                                            <tr *ngFor="let t of EmployeeDetail;let i = index">
                                                <td>{{t.EmployeeType}}</td>
                                                <td>{{t.NoOfPermanentEmployee}}</td>
                                                <td>{{t.NoOfAdhocEmployee}}</td>
                                                <td>{{t.TotalPermanentSalary}}</td>
                                                <td>{{t.TotalAdhocSalary}}</td>
                                                <td style="white-space: nowrap;">
                                                    <button type="button" class="btn btn-success mt-0 mb-0 d-inline"
                                                        (click)="editEmployeeDetail(i)">Edit</button>
                                                    &nbsp; <button type="button" class="btn btn-danger mt-0 d-inline"
                                                        (click)="deleteEmployeeDetail(i)">Delete</button>
                                                </td>
                                            </tr>
                                        </table>
                                    </div>
                                </div>
                            </div>
                            <div class="row  mt-2 p-3" *ngIf="documentList !=undefined && documentList.length > 0">
                                <div class="col-xl-12 col-md-12 col-12">
                                    <h4>College/Course Permission Letter</h4>
                                </div>
                                <div style="padding-left: 20px;padding-top: 10px;">
                                    <h6 style="color: red;"> 1) File size should be less then 1 MB.</h6>
                                    <h6 style="color: red;"> 2) You can upload jpg, jpeg, png or pdf file only.</h6>
                                </div>
                                <div class="table-responsive">
                                    <table id="example" class="table table-striped table-bordered" style="width:100%">
                                        <thead>
                                            <tr>
                                                <th class="pointer" scope="col">Sr. No.</th>
                                                <th class="pointer" scope="col">Course</th>
                                                <!-- <th class="pointer" scope="col">Document</th> -->
                                                <th class="pointer" scope="col">Preview</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr *ngFor="let r of documentList ;let i = index">
                                                <td>{{i+1}}</td>
                                                <td>
                                                    <p>{{r.text}}</p>
                                                </td>
                                                <!-- <td>
                                                    <input type="file" id="input-file-max-fs" id="customFile"
                                                        name="customFile" (change)="uploadImage($event,i)"
                                                        class="file-upload" data-max-file-size="2M" />
                                                </td> -->
                                                <td>
                                                    <p>
                                                        <a href="{{r.ViewURL}}" target="_blank">
                                                            <img src="{{r.downloadURL}}" class="img-fluid no-img "
                                                                style="width: 90px;height: 90px;" id="preview_{{i}}" />
                                                        </a>
                                                    </p>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                            <div class="row mt-2">
                                <div class="form-group col-lg-4 col-md-12 col-12">
                                    <label><b>Remarks</b></label>
                                    <textarea class="form-control" #Remarks="ngModel" ngModel name="Remarks" rows="3"
                                        maxlength="300" style="height: 60px;" [(ngModel)]="data.Remarks"></textarea>
                                </div>
                            </div>
                            <br>
                            <div class="row mt-2">
                                <button class="btn btn-success" type="button" id = "btnsubmit" (click)="updateRequest(data,1)"
                                    style="margin: 5px;">Approve</button>
                                <button class="btn btn-primary" type="button" id = "btnreject" (click)="updateRequest(data,2)"
                                    style="margin: 5px;">Reject</button>
                                <button class="btn btn-danger" type="button" style="margin: 5px;"
                                    (click)="redirectToList()">Cancel</button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="footer-login custom-footer">
        <p class="mb-0">Copyright © Netsol IT Solution Pvt. Ltd. 2020 All Rights Reserved</p>
        <img src="assets/images/powered-by.png" alt="netsol-powerd by" class="img-fluid">
    </div>
    <ngx-spinner bdcolor="rgba(51, 51, 51, 0.8)" size="default" type="ball-spin-clockwise">
        <p style="color: white;">Please Wait.</p>
    </ngx-spinner>
</div>